import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Video, FileVideo, HardDrive, Loader2 } from 'lucide-react';

function VideoUploadPreview({ selectedFile }) {
    const [isLoading, setIsLoading] = useState(true);
    const videoRef = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        setIsLoading(true);
        const video = videoRef.current;
        if (video) {
            video.onloadeddata = () => setIsLoading(false);
            video.onerror = () => setIsLoading(false);
        }
    }, [selectedFile]);

    return (
        <div className="rounded-[2.5rem] bg-white/5 backdrop-blur-md border border-white/10 shadow-xl overflow-hidden p-6 text-center animate-in fade-in zoom-in-95 duration-500">
            {/* Video Preview Title */}
            <div className="flex items-center justify-center gap-3 mb-6">
                <Video className="text-[#4c9fb9]" size={20} />
                <h3 className="text-lg font-black text-white uppercase tracking-widest">
                    {t('labels.videoPreview') || 'Video Vorschau'}
                </h3>
            </div>

            {/* Video Container */}
            <div className="relative group max-w-sm mx-auto rounded-3xl overflow-hidden border-2 border-white/10 bg-black/40 shadow-2xl transition-all duration-500 hover:border-[#4c9fb9]/50">
                <video
                    ref={videoRef}
                    key={selectedFile.name}
                    controls
                    className="w-full h-auto max-h-[250px] block"
                >
                    <source
                        src={URL.createObjectURL(selectedFile)}
                        type={selectedFile.type || 'video/mp4'}
                    />
                </video>

                {/* Loading Spinner */}
                {isLoading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm transition-opacity duration-300">
                        <div className="relative">
                            <Loader2 className="animate-spin text-[#4c9fb9]" size={48} />
                            <div className="absolute inset-0 blur-xl bg-[#4c9fb9]/20 rounded-full"></div>
                        </div>
                    </div>
                )}
            </div>

            {/* Video Info */}
            <div className="mt-8 space-y-3 px-4">
                <div className="flex items-center justify-between text-xs p-3 bg-white/5 rounded-2xl border border-white/5">
                    <div className="flex items-center gap-2 text-slate-400">
                        <FileVideo size={14} />
                        <span className="font-black uppercase tracking-widest">{t('labels.fileName') || 'Name'}:</span>
                    </div>
                    <span className="text-white font-bold truncate max-w-[150px]">{selectedFile.name}</span>
                </div>

                <div className="flex items-center justify-between text-xs p-3 bg-white/5 rounded-2xl border border-white/5">
                    <div className="flex items-center gap-2 text-slate-400">
                        <HardDrive size={14} />
                        <span className="font-black uppercase tracking-widest">{t('labels.fileSize') || 'Größe'}:</span>
                    </div>
                    <span className="text-emerald-500 font-black">{(selectedFile.size / 1024 / 1024).toFixed(2)} MB</span>
                </div>
            </div>
        </div>
    );
}

export default VideoUploadPreview;
